import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-bubble-chart',
	templateUrl:'./WaBubbleChartProPage.html',
	styles: [],
	styleUrls:['./WaBubbleChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaBubbleChartProPage
{
	mdContent_284 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaBubbleChart;
\`\`\``;
	mdContent_285 = `\`\`\`java
new WaBubbleChart<>()
\`\`\``;
}
